import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { TypographyStyles, TextColors } from '@/styles'
import { Icon, List, Text } from '@/ui'

export const HeardItem = ({ title }: { title: string }) => {
  return (
    <List.Item className="py-3 mb-5 flex items-center gap-3">
      <Icon
        className="inline-block"
        color={TextColors.GREEN}
        icon={solid('check')}
      />
      <Text variant={TypographyStyles.BODY_SM}>{title}</Text>
    </List.Item>
  )
}
